import {
    CREATE_ACCESSORIES_DC_DETAILS_FAILURE_DK,
    CREATE_ACCESSORIES_DC_DETAILS_REQUEST_DK,
    CREATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_ACCESSORIES_DC_DETAILS_DK,
    DELETE_ACCESSORIES_DC_DETAILS_FAILURE_DK,
    DELETE_ACCESSORIES_DC_DETAILS_REQUEST_DK,
    DELETE_ACCESSORIES_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_DETAILS_FAILURE_DK,
    FETCH_ACCESSORIES_DC_DETAILS_REQUEST_DK,
    FETCH_ACCESSORIES_DC_DETAILS_SUCCESS_DK,
    ACCESSORIES_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_ACCESSORIES_DC_DETAILS_FAILURE_DK,
    UPDATE_ACCESSORIES_DC_DETAILS_REQUEST_DK,
    UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST_DK,
    FETCH_GRN_NO_BY_ACCESSORIES_PO_REQUEST_DK,
    FETCH_GRN_NO_BY_ACCESSORIES_PO_FAILURE_DK,
    FETCH_GRN_NO_BY_ACCESSORIES_PO_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_DETAILS_STYLE_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_DETAILS_STYLE_FAILURE_DK,
    FETCH_ACCESSORIES_DC_DETAILS_STYLE_REQUEST_DK,
    FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_REQUEST_DK,
    FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_SUCCESS_DK,
    FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_FAILURE_DK,
    FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_REQUEST_DK,
    FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_FAILURE_DK,
    FETCH_ACCESSORIES_DC_DETAILS_STITCHING_REQUEST_DK,
    FETCH_ACCESSORIES_DC_DETAILS_STITCHING_SUCCESS_DK,
    FETCH_ACCESSORIES_DC_DETAILS_STITCHING_FAILURE_DK,
} from './accessoriesDCDetails.actionsType';

export const ACCESSORIES_DC_DETAILS_DK = 'accessoriesDCDetailsDK';

let initialState = {
    loading: false,
    accessoriesDCDetailsById: [],
    AccessoriesPOInAccessoriesDC: [],
    grnNoByAccessoriesPO:[],
    accessoriesDCDetails: [],
    accessoriesDCDetailStyleList:[],
    accessoriesDCIronPackDCNoList:[],
    accessoriesDCStitchingDCNOList:[],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedAccessoriesDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let accessoriesDCDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_DC_DETAILS_REQUEST_DK:
        case FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_REQUEST_DK:
        case FETCH_ACCESSORIES_DC_DETAILS_STITCHING_REQUEST_DK:
        case FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_REQUEST_DK:
        case FETCH_ACCESSORIES_DC_DETAILS_STYLE_REQUEST_DK:
        case FETCH_GRN_NO_BY_ACCESSORIES_PO_REQUEST_DK:
        case FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_ACCESSORIES_DC_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST_DK:
        case UPDATE_ACCESSORIES_DC_DETAILS_REQUEST_DK:
        case DELETE_ACCESSORIES_DC_DETAILS_REQUEST_DK:
        case FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
            case FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    AccessoriesPOInAccessoriesDC: updatePayload?.PRD
                };
        case FETCH_ACCESSORIES_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesDCDetails: updatePayload
            };
            case FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesDCIronPackDCNoList: updatePayload
            };
            case FETCH_ACCESSORIES_DC_DETAILS_STITCHING_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesDCStitchingDCNOList: updatePayload
            };
            case FETCH_GRN_NO_BY_ACCESSORIES_PO_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    grnNoByAccessoriesPO: updatePayload?.Inward
                };
        case FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesDCDetailsById: updatePayload
            };

        case CREATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                grnNoByAccessoriesPO: []
            };
            case FETCH_ACCESSORIES_DC_DETAILS_STYLE_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    accessoriesDCDetailStyleList: updatePayload?.PONO
                    //PRD
                };
        case FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedAccessoriesDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_ACCESSORIES_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedAccessoriesDCDetails: {}
            };

        case FETCH_ACCESSORIES_DC_DETAILS_FAILURE_DK:   
        case FETCH_ACCESSORIES_DC_DETAILS_STITCHING_FAILURE_DK:
        case FETCH_ACCESSORIES_DC_DETAILS_IRONPACK_FAILURE_DK:
        case FETCH_ACCESSORIES_PO_IN_ACCESSORIES_DC_FAILURE_DK:
        case FETCH_ACCESSORIES_DC_DETAILS_STYLE_FAILURE_DK:
        case FETCH_GRN_NO_BY_ACCESSORIES_PO_FAILURE_DK:
        case FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE_DK:
        case CREATE_ACCESSORIES_DC_DETAILS_FAILURE_DK:
        case UPDATE_ACCESSORIES_DC_DETAILS_FAILURE_DK:
        case DELETE_ACCESSORIES_DC_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case ACCESSORIES_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedAccessoriesDCDetails: {}
            };
        default:
            return state;
    }
};
